import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

const integrations = {
  SIEM: [
    {
      id: 'splunk',
      name: 'Splunk',
      description: 'Enterprise SIEM platform with advanced analytics and correlation capabilities.',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/f/f8/Splunk_logo.png'
    },
    {
      id: 'qradar',
      name: 'IBM QRadar',
      description: 'Intelligent security analytics for actionable insights.',
      logo: 'https://flashpoint.io/wp-content/uploads/integrations-logo-qradar.png'
    },
    {
      id: 'elastic',
      name: 'Elastic',
      description: 'Open, unified SIEM solution for search, analysis, and visualization.',
      logo: 'https://cdn.worldvectorlogo.com/logos/elastic.svg'
    },
    {
      id: 'fortisiem',
      name: 'FortiSIEM',
      description: 'Unified event correlation and risk management platform.',
      logo: 'https://www.fortinet.com/content/dam/fortinet/images/general/fortinet-logo.svg'
    },
    {
      id: 'datadog',
      name: 'Datadog',
      description: 'Cloud-scale security monitoring and threat detection.',
      logo: 'https://www.cdnlogo.com/logos/d/11/datadog-wordmark.svg'
    }
  ],
  EDR: [
    {
      id: 'crowdstrike',
      name: 'CrowdStrike Falcon',
      description: 'Cloud-native endpoint protection with AI-powered threat prevention.',
      logo: 'https://assets.datamation.com/uploads/2021/09/CrowdStrike-logo.png'
    },
    {
      id: 'sentinelone',
      name: 'SentinelOne',
      description: 'Autonomous endpoint protection powered by machine learning.',
      logo: 'https://www.arrow.com/globalecs-media/zy0lcjoc/sentinel-one-logo.png'
    },
    {
      id: 'defender',
      name: 'Microsoft Defender',
      description: 'Integrated threat protection for endpoints and cloud workloads.',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Windows_Defender_logo.svg/800px-Windows_Defender_logo.svg.png'
    },
    {
      id: 'sophos',
      name: 'Sophos',
      description: 'Next-gen endpoint protection and response.',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Sophos_logo.svg/640px-Sophos_logo.svg.png'
    },
    {
      id: 'trendmicro',
      name: 'TrendMicro Vision One',
      description: 'XDR platform for advanced threat detection and response.',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/Trend_Micro_logo.svg/2560px-Trend_Micro_logo.svg.png'
    },
    {
      id: 'cortex',
      name: 'Palo Alto Cortex XDR',
      description: 'Extended detection and response across all security data.',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/PaloAltoNetworks_2020_Logo.svg/2560px-PaloAltoNetworks_2020_Logo.svg.png'
    },
    {
      id: 'carbonblack',
      name: 'VMware Carbon Black',
      description: 'Cloud-native endpoint and workload protection.',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/11/CarbonBlack-Logo-Primary-Black.png/1200px-CarbonBlack-Logo-Primary-Black.png'
    },
    {
      id: 'forticlient',
      name: 'Fortinet FortiClient',
      description: 'Integrated endpoint protection and secure remote access.',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/6/62/Fortinet_logo.svg'
    },
    {
      id: 'catonetworks',
      name: 'CATO Networks',
      description: 'Cato provides a world-leading single-vendor SASE platform.',
      logo: 'https://www.criticalcase.com/wp-content/uploads/2020/10/cato-logo@2x.png'
    }
  ]
};

export function Integrations() {
  return (
    <div className="p-6 space-y-6">
      <h1 className="text-3xl font-ibm-condensed">Integrations</h1>

      {Object.entries(integrations).map(([category, items]) => (
        <div key={category} className="space-y-4">
          <div className="flex items-center gap-2">
            <h2 className="text-2xl font-ibm-condensed">{category}</h2>
            <Badge variant="secondary">{items.length}</Badge>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((integration) => (
              <Card key={integration.id} className="overflow-hidden hover:shadow-lg transition-shadow">
                <CardHeader className="space-y-0 pb-4">
                  <div className="h-12 flex items-center justify-center bg-card">
                    <img
                      src={integration.logo}
                      alt={`${integration.name} logo`}
                      className="h-8 object-contain transition-all duration-300 dark:grayscale dark:invert dark:opacity-70 dark:hover:opacity-100"
                    />
                  </div>
                </CardHeader>
                <CardContent>
                  <div className="space-y-2">
                    <CardTitle className="text-xl">{integration.name}</CardTitle>
                    <div className="text-sm text-muted-foreground">
                      {integration.description}
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}